export const API_ENDPOINT_V1 = process.env.REACT_APP_API_V1
